import { render, staticRenderFns } from "./EntityIdentities.vue?vue&type=template&id=c977a862"
import script from "./EntityIdentities.vue?vue&type=script&lang=js"
export * from "./EntityIdentities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports